import React, { useState, useEffect, useRef } from 'react';

const VenueAboutInfo = ({ description }) => {
    const [isDescriptionExpanded, setIsDescriptionExpanded] = useState(false);
    const [showReadMore, setShowReadMore] = useState(false);
    const descriptionRef = useRef(null);

    useEffect(() => {
        if (descriptionRef.current) {
            // Check if content is overflowing (clamped)
            const element = descriptionRef.current;
            setShowReadMore(element.scrollHeight > element.clientHeight);
        }
    }, [description]);

    return (
        <div className="flex flex-col gap-2 mb-8">
        <h2 className='venue-section-title'>About the space</h2>
        <p
          ref={descriptionRef}
          className={`vd-body-text whitespace-pre-line ${!isDescriptionExpanded ? 'line-clamp-3' : ''}`}
        >
          {description || 'No description available'}
        </p>
        {showReadMore && (
          <button
            onClick={() => setIsDescriptionExpanded(!isDescriptionExpanded)}
            className="vd-link self-start"
          >
            {isDescriptionExpanded ? 'Read less' : 'Read more'}
          </button>
        )}
      </div>

    )
}

export default VenueAboutInfo;